import React from "react";
import { motion } from "framer-motion";

export const Section = ({ children, className = "", id }) => (
  <section id={id} className={`px-6 lg:px-10 ${className}`}>
    <div className="max-w-7xl mx-auto">{children}</div>
  </section>
);

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false }) => (
  <span
    className={`uppercase tracking-[0.25em] text-xs font-semibold ${
      dark ? "text-coral" : "text-coral"
    }`}
  >
    {children}
  </span>
);
